<div class="content" [ngClass]="active ? 'd-block' : 'd-none'">
  <ng-content></ng-content>
</div>